import { ProjectAlternativeState } from './alternative/alternative.state';
import { ProjectBreadcrumbsState } from './breadcrumbs/breadcrumbs.state';
import { ProjectConnectedUsersState } from './connected-users/connected-users.state';
import { DatasheetState } from './datasheet/datasheet.state';
import { ProjectState } from './project/project.state';
import { ProjectSelectionsState } from './selection/selections.state';
import { ProjectStudyState } from './study/study.state';
import { UnitConfigurationState } from './unit-configuration/unit-configuration.state';
import { ProjectUnitTemplateState } from './unit-template/unit-template.state';

export const PROJECT_CHILD_STATES = [
  ProjectSelectionsState,
  ProjectBreadcrumbsState,
  ProjectConnectedUsersState,
  ProjectAlternativeState,
  ProjectUnitTemplateState,
  ProjectStudyState,
  DatasheetState,
  UnitConfigurationState,
];

export const PROJECT_STATE = [ProjectState, ...PROJECT_CHILD_STATES];
